import React from 'react';
export const Facebook = ({ title, ...rest }) => (
  <svg viewBox="0 0 500 1074.3" {...rest}>
    {title && <title>{title}</title>}
    <path d="M108.9 212.9v148.5H0v178.2h108.9v534.7h222.8V539.6h148.5s14.9-84.2 19.8-183.2H331.7V232.6s24.8-44.6 49.5-44.6H500V-.1c-59.4 5-133.7 5-163.4 5-232.6.1-227.7 183.2-227.7 208z" />
  </svg>
);
